import { handleActions } from 'redux-actions';
import { GET_POINTS } from './../constants';

export const getPointsState = handleActions({
  [GET_POINTS]: (state, action) => {
    return {...action.payload};
  },
}, {});
